<template>
  <div class="allscene-container">
    <div class="hexagon-grid">
      <!-- 第一行：1个图标 -->
      <div class="hexagon-item hexagon-item-1" @click="handleClick('智能客服')">
        <div class="hexagon">
          <img src="~@/assets/imgs/case/allscene/Slice 164.png" alt="智能客服" />
        </div>
        <div class="hexagon-label">智能客服</div>
      </div>

      <!-- 第二行：2个图标 -->
      <div class="hexagon-item hexagon-item-2" @click="handleClick('岗位训练')">
        <div class="hexagon">
          <img src="~@/assets/imgs/case/allscene/Slice 164(1).png" alt="岗位训练" />
        </div>
        <div class="hexagon-label">岗位训练</div>
      </div>
      <div class="hexagon-item hexagon-item-3" @click="handleClick('投资分析与策略制定')">
        <div class="hexagon">
          <img src="~@/assets/imgs/case/allscene/Slice 164(2).png" alt="投资分析与策略制定" />
        </div>
        <div class="hexagon-label">投资分析与策略制定</div>
      </div>

      <!-- 第三行：3个图标 -->
      <div class="hexagon-item hexagon-item-4" @click="handleClick('金融风险管理')">
        <div class="hexagon">
          <img src="~@/assets/imgs/case/allscene/Slice 164(3).png" alt="金融风险管理" />
        </div>
        <div class="hexagon-label">金融风险管理</div>
      </div>
      <div class="hexagon-item hexagon-item-5" @click="handleClick('商务数据分析智能体')">
        <div class="hexagon">
          <img src="~@/assets/imgs/case/allscene/Slice 164(4).png" alt="商务数据分析智能体" />
        </div>
        <div class="hexagon-label">商务数据分析智能体</div>
      </div>
      <div class="hexagon-item hexagon-item-6" @click="handleClick('金融反欺诈')">
        <div class="hexagon">
          <img src="~@/assets/imgs/case/allscene/Slice 164(5).png" alt="金融反欺诈" />
        </div>
        <div class="hexagon-label">金融反欺诈</div>
      </div>

      <!-- 第四行：2个图标 -->
      <div class="hexagon-item hexagon-item-7" @click="handleClick('智能保险推荐')">
        <div class="hexagon">
          <img src="~@/assets/imgs/case/allscene/Slice 164(6).png" alt="智能保险推荐" />
        </div>
        <div class="hexagon-label">智能保险推荐</div>
      </div>
      <div class="hexagon-item hexagon-item-8" @click="handleClick('金融合规与监管')">
        <div class="hexagon">
          <img src="~@/assets/imgs/case/allscene/Slice 164(7).png" alt="金融合规与监管" />
        </div>
        <div class="hexagon-label">金融合规与监管</div>
      </div>
    </div>

    <div class="main-title-container">
      <div class="main-title">AI赋能金融全场景</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AllScene',
  data () {
    return {
      // 可以在这里添加组件数据
    }
  },
  methods: {
    // 可以在这里添加组件方法
    handleClick (type) {
      sessionStorage.setItem('sceneType', type)
      this.$router.push({
        path: '/case/caseselect',
      })
    }
  }
}
</script>

<style lang="less" scoped>
.allscene-container {
  width: 100%;
  // height: 100vh;
  height: 100%;
  background-image: url('~@/assets/imgs/case/allscene/Slice 167.png');
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // padding: 20px;
  position: relative;
  overflow: hidden;

  // 添加背景光效
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 50% 50%, rgba(0, 100, 255, 0.1) 0%, transparent 70%);
    z-index: 0;
  }
}

.hexagon-grid {
  width: 100%;
  height: 80%;
  max-width: 1200px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.hexagon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
}

/* 绝对定位布局 */
.hexagon-item-1 {
  top: 0%;
  left: 50%;
  transform: translateX(-50%);
}

.hexagon-item-2 {
  top: 10%;
  left: 35%;
  transform: translateX(-50%);
}

.hexagon-item-3 {
  top: 10%;
  left: 65%;
  transform: translateX(-50%);
}

.hexagon-item-4 {
  top: 25%;
  left: 20%;
  transform: translateX(-50%);
}

.hexagon-item-5 {
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
}

.hexagon-item-6 {
  top: 25%;
  left: 80%;
  transform: translateX(-50%);
}

.hexagon-item-7 {
  top: 45%;
  left: 35%;
  transform: translateX(-50%);
}

.hexagon-item-8 {
  top: 45%;
  left: 65%;
  transform: translateX(-50%);
}

.hexagon {
  width: 150px;
  height: 175px;
  background-image: url('~@/assets/imgs/case/allscene/Slice 165.png');
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  img {
    width: 70%;
    height: 70%;
    object-fit: contain;
  }

  // 悬停效果
  &:hover {
    transform: translateY(-5px);
  }
}

// 脉冲动画
@keyframes pulse {

  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}

.hexagon-label {
  margin-top: 10px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  text-shadow: 0 0 10px rgba(0, 150, 255, 0.5);
}

.main-title-container {
  width: 100%;
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translateX(-50%);
}



.main-title {
  color: white;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
  text-shadow: 0 0 20px rgba(0, 150, 255, 0.8);
  position: relative;
  z-index: 1;

}

// 响应式设计
@media (max-width: 768px) {
  .hexagon-grid {
    width: 95%;
    gap: 15px;
  }

  .hexagon {
    width: 80px;
    height: 80px;
  }

  .hexagon-label {
    font-size: 14px;
  }

  .main-title {
    font-size: 24px;
  }
}
</style>